import fitty from 'fitty';
import Rellax from 'rellax';

export default {
  finalize() {
    const fitties = fitty('.fitty-span');

    window.setTimeout(() => {
      fitties.forEach((fitty) => {
        fitty.fit();
      });

      new Rellax('.rellax');
      
    }, 100);
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js